export default [
	{
	    path: "caiwu/package-mg",
	    name: "PackageMg",
	    component: ()=> import('./package-mg.vue')
	},
	{
	    path: "caiwu/package-mg-add",
	    name: "PackageMgAdd",
	    component: () => import('./package-mg-add.vue')
	},
	{
	    path: "caiwu/package-mg-edit",
	    name: "PackageMgEdit",
	    component: () => import('./package-mg-edit.vue')
	},
];






